@if (url$ | async; as urlObject) {
    <a [routerLink]="urlObject.path"
       [queryParams]="urlObject.queryParams"
       class="btn btn-link">{{ buttonText }}</a>
}
